export const authTranslations = {
  // Login
  login: '로그인',
  email: '이메일',
  emailPlaceholder: 'name@work-email.com',
  password: '비밀번호',

  forgotPassword: '비밀번호를 잊으셨나요?',
  dontHaveAccount: '계정이 없으신가요?',
  signUp: '무료로 가입하기',
  Korean: '한국어',
  continueWithEmail: '이메일로 계속하기',
  enterYourPassword: '비밀번호를 입력해주세요',
  enterYourPasswordDescription: '비밀번호를 입력하여 로그인해주세요.',

  // Social Sign-In
  continueWithGoogle: 'Google로 계속하기',
  continueWithKakao: '카카오로 계속하기',
  continueWithMicrosoft: 'Microsoft로 계속하기',
  OR: '또는',
  socialSignInError: '소셜 로그인에 문제가 발생했습니다. 다시 시도해주세요.',

  // Sign Up
  createAccount: '계정 만들기',
  createAccountSubtitle: '회원가입 시 사내 이메일 주소 사용을 권장합니다.',
  createPassword: '비밀번호 생성',
  createPasswordDescription: '계정에서 사용할 새 비밀번호를 설정해주세요.',
  firstName: '이름',
  lastName: '성',
  passwordPlaceholder: '새로운 비밀번호',
  passwordConfirm: '비밀번호 확인',
  passwordConfirmPlaceholder: '비밀번호 확인',
  passwordConfirmError: '비밀번호가 일치하지 않습니다.',
  passwordConfirmErrorMessage: '비밀번호가 일치하지 않습니다.',
  at8Characters: '최소 8자 이상',
  useOfUppercase: '대문자, 소문자, 숫자, 특수문자 중 3가지 이상 조합',
  alreadyHaveAccount: '이미 계정이 있으신가요?',
  personalInformation: '사용자 정보',
  company: '회사명',
  position: '직책',
  continue: '계속',
  Email: '이메일',
  signupComplete: '회원가입 완료',
  signupCompleteSubtitle: '새로운 계정으로 로그인해주세요.',
  incorrectUsernameOrPassword:
    '이메일 또는 비밀번호가 일치하지 않습니다. 다시 시도해주세요.',
  passwordAttemptsExceeded:
    '비밀번호 시도 횟수를 초과했습니다. 잠시 후 다시 시도해주세요.',
  userDoesNotExist: '존재하지 않는 계정입니다. 회원가입 후 로그인해주세요.',
  loginFailed: '로그인에 실패했습니다. 다시 시도해주세요.',
  whatsYourName: '이름을 알려주세요',
  enterYourNameDescription:
    '이름을 입력해주세요. 등록 후에도 수정이 가능합니다.',
  name: '이름',

  // Email Verification
  weEmailedYou: '이메일을 발송했습니다',
  weEmailedYouDescription:
    '새 비밀번호를 설정하려면 {{email}}로 전송된 코드를 입력하세요. 도착까지 1분 정도 걸릴 수 있습니다.',
  codeOnTheWay:
    '코드가 발송되었습니다. 로그인하려면 {{email}}로 전송된 코드를 입력하세요. 도착까지 1분 정도 걸릴 수 있습니다.',
  codeOnTheWay2: '입력하세요',
  codeDelay: '도착까지 1분 정도 걸릴 수 있습니다.',
  enterYourCode: '코드를 입력하세요',
  confirm: '확인',
  resendCode: '코드 다시 받기',
  codeInvalid: '입력한 코드가 유효하지 않습니다.',
  somethingWentWrong: '오류가 발생했습니다. 다시 시도해주세요.',
  codeResent: '코드가 재전송되었습니다. 이메일을 확인해주세요.',
  codeLimitExceeded: '코드 재전송 횟수를 초과했습니다. 다시 시도해주세요.',
  discoverRateLimited:
    '요청이 너무 많습니다. 잠시 후 다시 시도해주세요.',

  // Password Reset
  resetPassword: '비밀번호 재설정',
  resetPasswordDescription:
    '비밀번호를 재설정하려는 계정의 이메일을 입력해주세요.',
  checkInbox: '메일함을 확인해주세요',
  enterYourEmail: '이메일을 입력해주세요.',
  passwordChanged: '비밀번호 변경 완료',
  loginWithNewPassword: '새로운 비밀번호로 로그인해주세요.',
  createNewPassword: '새 비밀번호 설정',
  createNewPasswordDescription1: '계정에서 사용할 새 비밀번호를 설정해주세요.',
  createNewPasswordDescription2:
    '새 비밀번호는 최소 8자 이상, 대문자, 소문자, 숫자, 특수문자를 포함해야 합니다.',
  newPassword: '새 비밀번호',
  confirmNewPassword: '새 비밀번호 확인',
  backtoLogin: '로그인 화면으로 돌아가기',
  code: '코드',
  checkInboxDescription: '방금 전송한 인증 코드를 {{email}}에서 확인해주세요.',
  updatePassword: '비밀번호 변경하기',
  loggingIn: '로그인하는 중...',
  loggingInDescription: '곧 Cheiron으로 이동합니다...',
  codeValidationError: '잘못된 인증 코드입니다. 다시 확인 후 시도해주세요.',
  resendEmail: '이메일 다시 받기',

  // Password Requirements
  passwordLength8:
    '비밀번호는 최소 8자 이상, 대문자, 소문자, 숫자, 특수문자를 최소 3가지 이상 조합해야 합니다.',
  passwordNotMatch: '비밀번호가 일치하지 않습니다.',
  passwordChangedDescription:
    '비밀번호가 변경되었습니다. \n 새로운 비밀번호로 로그인해주세요.',
  passwordUpdateFailed: '비밀번호 변경에 실패했습니다. 다시 시도해주세요.',

  // Account Deletion
  deleteAccount: '계정 삭제',
  deleteAccountDescription:
    '삭제를 확인하려면 계정에 연결된 비밀번호를 입력해주세요.',
  enterPassword: '비밀번호를 입력하세요',
  passwordRequired: '비밀번호가 필요합니다',
  deletingAccount: '계정 삭제하는 중',
  accountDeleted: '계정이 성공적으로 삭제되었습니다',
  accountDeletionFailed: '계정 삭제에 실패했습니다. 다시 시도해주세요.',
  DeleteYourAccount: '계정을 삭제하시겠습니까?',
  YouNeedToLogInAgain: '계정을 삭제하려면 다시 로그인해야 합니다.',
  LogInToDelete: '로그인하여 삭제',
  DeletionComplete: '삭제 완료',
  YourAccountHasBeenDeleted: '계정이 성공적으로 삭제되었습니다.',

  //validations
  enterValidEmail: '올바른 이메일 주소를 입력해주세요.',
  enterValidFirstName: '올바른 이름을 입력해주세요.',
  enterValidLastName: '올바른 성을 입력해주세요.',
  enterValidName: '올바른 이름을 입력해주세요.',
  thisEmailAlreadyRegistered: '이미 등록된 이메일입니다.',
  preSignUpFailedErrorMessage: '이미 같은 계정이 존재합니다.',
  enterValidPassword: '올바른 비밀번호를 입력해주세요.',

  // Legal
  termsOfService: '서비스 이용약관',
  privacyPolicy: '개인정보 처리방침',
  adminPage: '관리자 페이지',

  agreementText1:
    '‘가입하기’ 버튼을 클릭하면 이용약관 및 개인정보처리방침에 동의하신 것으로 간주됩니다.',
  // Language
  english: '영어',
  korean: '한국어',

  // Job Categories
  positionCategories: {
    researchRD: '연구개발 (R&D)',
    researchRDDetails: '연구원, 연구직, 실험실 스태프, 신약 발굴, 전임상 연구',

    salesMarketing: '영업 및 마케팅 (Sales & Marketing)',
    salesMarketingDetails: '영업, 마케팅, 제품 매니저, 의약품 영업 담당자',

    manufacturingQuality: '제조 및 품질 (Manufacturing & Quality)',
    manufacturingQualityDetails:
      'CMC(의약품 개발 및 제조관리), 품질보증(QA), 품질관리(QC), 엔지니어링(ENG), 제조 공학기술(MSAT), 공급망관리(SCM)',

    clinicalDevelopment: '임상개발 (Clinical Development)',
    clinicalDevelopmentDetails:
      '임상 운영, 임상 연구, 메디컬 모니터, 스터디 코디네이터, 임상 데이터 관리, 통계분석',

    businessOperations: '경영 지원 (Business Operations)',
    businessOperationsDetails: '사업 개발, 재무, 법무, 인사(HR)',

    medicalAffairs: '의료부서 (Medical Affairs)',
    medicalAffairsDetails:
      'MSL(메디컬 사이언스 리에종), 의학정보 제공, 메디컬 커뮤니케이션',

    marketAccess: '시장 접근 (Market Access, MA)',
    marketAccessDetails: '건강경제학, 약가 및 급여 등재, 가격 책정',

    regulatoryAffairs: '허가 (Regulatory Affairs, RA)',
    regulatoryAffairsDetails: '규제 및 인허가 업무',

    pharmacovigilance: '약물감시 및 안전관리 (Pharmacovigilance / Safety)',
    pharmacovigilanceDetails: '약물감시(PV), 의약품 안전성, 리스크 관리',

    informationTechnology: '정보기술 (Information Technology)',
    informationTechnologyDetails: 'IT',

    physicianProfessor: '의료진 / 교수진 (Physician / Professor)',
    physicianProfessorDetails:
      'KOL, 임상시험 책임자(Investigator), 학계 종사자, 의료 전문가(HCP)',

    others: '기타 (Others)',
    othersDetails: '직접 기재',
  },

  //Settings
  Settings: '설정',
  MyProfile: '내 프로필',
  Save: '저장',
  Saving: '저장중',
  Security: '보안',
  Language: '언어',
  Organization: '조직',
  Institution: '기관명',
  TermsofUse: '이용약관',
  PrivacyPolicy: '개인정보 처리방침',
  Account: '계정',
  Terms: '약관',
  ProfileUpdatedSuccessfully: '프로필이 성공적으로 업데이트되었습니다.',
  YourPasswordHasBeenUpdated: '비밀번호가 업데이트되었습니다.',
  ChangePassword: '비밀번호 설정',
  SignInWithYourPassword:
    '소셜로그인에 접근할 수 없는 경우, 비밀번호를 사용하여 로그인',
  DeleteAccount: '계정 삭제',
  CannotDeleteAccount: '계정을 삭제할 수 없습니다',
  GotIt: '확인',
  PermanentlyDeleteYourAccount: '계정을 영구적으로 삭제하기',
  AccountDeletionNotAllowedForExternalDomain:
    '계정 삭제는 도메인 관리자만 가능합니다.',
  ThisAccountIncludesAnExternalDomain:
    '이 계정은 관리되는 도메인에 연결되어 있습니다.',
  AccountDeletionIsOnlyAllowedForTheDomainAdministrator:
    '해당 도메인의 관리자에게 문의해 계정을 먼저 제거해주세요.',
  DeleteAccountConfirmTitle: '계정을 삭제하시겠습니까?',
  DeleteAccountConfirmDescription:
    '계정삭제를 확인하려면 계정에 연결된 이메일을 입력해주세요.',
  EnterYourEmailToConfirm: '확인을 위해 이메일을 입력하세요',
  EmailDoesNotMatch: '이메일이 일치하지 않습니다.',
  Deleting: '삭제 중',
  AccountDeletedSuccessfully: '계정이 성공적으로 삭제되었습니다.',
  ErrorDeletingAccount: '계정 삭제 중 오류가 발생했습니다.',

  // Change Password
  resetYourPassword: '비밀번호 재설정',
  enterNewPasswordBelow: '새로운 비밀번호를 입력하여 비밀번호를 변경하세요.',
  currentPassword: '현재 비밀번호',
  resetPasswordButton: '비밀번호 재설정',
  yourPasswordHasBeenChanged: '비밀번호가 변경되었습니다!',
  yourPasswordHasBeenResetDescription:
    '비밀번호가 재설정되었습니다. 이제 설정화면으로 돌아갑니다.',
  continueButton: '계속',
  incorrectCurrentPassword: '현재 비밀번호가 일치하지 않습니다.',

  //error
  PleaseEnterYourFirstName: '이름을 입력해주세요.',
  PleaseEnterYourPosition: '직책을 입력해주세요.',
  PleaseEnterYourEmail: '이메일을 입력해주세요.',
  PleaseEnterYourOrganization: '조직/기관명을 입력해주세요.',
  loginSignup: '로그인 ・ 회원가입',
  loginDescription: '로그인 또는 회원가입을 하여 계속하세요.',
  LanguageUpdated: '언어 설정이 업데이트되었습니다!',
  ManageYourAccountSecuritySettings: '계정 보안 설정을 관리하세요',
  KeepYourAccountSecure: '계정 보안을 유지하세요',
  DomainsLinkedToYourAccount: '계정에 연결된 도메인',
  PermanentlyDeleteYourAccountAndAllAssociatedData:
    '계정 및 모든 데이터를 영구적으로 삭제합니다',
  PermanentlyDeleteYourAccountAcrossAllDomains:
    '계정 및 연결된 도메인을 영구적으로 삭제합니다',
  gobacktooltip: '이전 페이지로 돌아가기',

  // Tenant Selection
  SelectDomain: '도메인 선택',
  ChooseDomainDescription: '사용할 도메인을 선택해주세요.',
  Managed: '외부도메인',

  // logout
  Logout: '로그아웃',

  // Tenant proposal (whitelisted domain signup)
  tenantProposalTitlePrefixEn: 'Are you part of ',
  tenantProposalTitleSuffixKr: ' 소속이신가요?',
  tenantProposalDescriptionEn1: 'A company tenant is available for ',
  tenantProposalDescriptionEn2: '.',
  tenantProposalDescriptionEn3:
    'If you sign up on this page, your account will be created on the Free plan with limited access to enterprise features.',
  tenantProposalDescriptionKr1: '님을 위한 고객사 전용 테넌트가 준비되어 있습니다.',
  tenantProposalDescriptionKr2:
    '현재 페이지는 일반 공개용 Cheiron입니다. 회원 가입을 진행하시면 기업 전용 기능이 제한된 Free 플랜 계정으로 가입됩니다.',
  tenantProposalQuestion: '기업 전용 페이지로 이동하시겠습니까?',
  tenantProposalCurrentPage: '현재 페이지',
  tenantProposalCompanyPage: '기업 전용 페이지',
  tenantProposalGo: '이동하기',
  tenantProposalContinuePublic: '일반 Cheiron으로 계속하기',
}
